// ============================================================================
// FONT CONFIGURATION - Centralized font definitions
// ============================================================================

export const FONTS = {
    // Avenir Font Family
    avenir: {
        black: 'Avenir Black',
        heavy: 'Avenir Heavy',
        medium: 'Avenir Medium',
    },

    // Poppins Font Family
    poppins: {
        light: 'Poppins Light',
        medium: 'Poppins Medium',
        bold: 'Poppins Bold',
    },
} as const;

// Font usage mapping for consistency
export const FONT_USAGE = {
    // Headings and titles
    headings: FONTS.avenir.black,
    subheadings: FONTS.avenir.heavy,

    // Body text
    body: FONTS.avenir.medium,

    // Special text elements
    accent: FONTS.poppins.light,
    emphasis: FONTS.poppins.bold,
    medium: FONTS.poppins.medium,
} as const;

export default FONTS;
